import { TDateAppFormat } from '@/domains/types';

import dayjs from '../dayjsConfig';

type TGetDateDiff = {
  firstDate: number | TDateAppFormat | null | undefined | string,
  secondDate: number | TDateAppFormat | null | undefined | string,
  timeZone?: string,
  unit?: 'day' | 'week' | 'month' | 'year' | 'hour' | 'minute' | 'second',
  float?: boolean,
};

const getDateDiff = ({
  firstDate,
  secondDate = dayjs(),
  timeZone,
  unit,
  float = false,
}: TGetDateDiff): number => (timeZone ? dayjs.tz(firstDate, timeZone) : dayjs(firstDate))
  .diff(timeZone ? dayjs.tz(secondDate, timeZone) : dayjs(secondDate), unit, float);

export default getDateDiff;
